<template>
  <div class="unit-switcher-root flex justify-between items-center" :class="layout">
    <span class="unit" :class="{ active: !useInch }" @click="$emit('toggle', false)">{{
      $t('settingUserData.cm')
    }}</span>
    <span class="separator">{{ layout === 'white' ? '' : '|' }}</span>
    <span class="unit" :class="{ active: useInch }" @click="$emit('toggle', true)">{{
      $t('settingUserData.inch')
    }}</span>
  </div>
</template>

<script>
export default {
  name: 'UnitSwitcher',
  props: {
    useInch: Boolean,
    layout: String,
  },
};
</script>

<style lang="scss" scoped>
.unit-switcher-root {
  max-width: 90px;
  color: #8c8c8c;
  &.dark {
    color: black;
    .unit.active {
      color: black;
    }
  }

  &.white {
    @apply rounded-full;
    max-width: initial;
    width: 91px;
    height: 24px;
    color: #7a7a7a;
    border: 1px solid #979797;

    @screen md {
      width: 125px;
      height: 40px;
    }

    .separator {
      width: 1px;
      height: 100%;
      background-color: #979797;
    }

    .unit {
      @apply text-center;
      display: inline-flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      width: 45px;
      &.active {
        color: black;
      }

      @screen md {
        width: 62px;
      }
    }
  }
}

.unit {
  @apply text-xxs;
  opacity: 0.5;
  cursor: pointer;
  @screen md {
    font-size: 18px;
  }

  &.active {
    opacity: 1;
    color: #540deb;
  }
}
</style>
